<div class="body">

    <div class="headline">
        {{headline}}
    </div>

    <div class="desc">
        Bitte haben Sie einen Moment Geduld. Wir informieren Sie zeitnah, sollte die Aktion abgeschlossen sein oder sollten Fehler auftreten.
    </div>

    <mat-spinner diameter="50"></mat-spinner>

</div>